<template>
<x-y-chart
  :data-config="formatDataConfig"
  :unit-prop="unitProp"
  chart-type="line"
  :stack-type="0"
  download-name="物种比值"
  selected-change-with-data-changed
  :show-selected-ctrl-btn="false"
  :show-legend="false"
  :y-axis-scale="false"
  chart-min-height="245px"
  chart-height="auto"
/>
</template>

<script>
import XYChart from '../../../../../components/DataChart/XYChart'

export default {
  name: 'RatioChart',
  components: {XYChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    ratioLow: {
      required: true,
      type: Number
    },
    unitProp: {
      required: true,
      type: String
    }
  },
  computed: {
    formatDataConfig () {
      let {dataConfig, ratioLow} = this
      let {dimensions: [dimension1, dimension2], seriesMap, dataTimes} = dataConfig
      let dimensionId1 = dimension1.id
      let name1 = dimension1.name
      let dimensionId2 = dimension2.id
      let name2 = dimension2.name
      let ratioId = `${dimensionId1}-${dimensionId2}`
      let series1 = seriesMap[dimensionId1]
      let series2 = seriesMap[dimensionId2]
      let newDimensions = [{
        id: ratioId,
        name: `${name1}/${name2}`,
        stdUnit: '',
        displayUnit: '',
        displayUnit1: dimension1[this.unitProp],
        id1: dimensionId1,
        id2: dimensionId2,
        name1,
        name2,
        getTooltip: (dimension, marker, seriesName, value, seriesId, data = {}) => {
          const isHaveIntegral1 = data[dimension.id1 + 'Integral']
          const displayFlags1 = data[dimension.id1 + 'DisplayFlags'] || []
          const flags1 = []

          if (isHaveIntegral1) {
            flags1.push('重积分')
          }

          if (displayFlags1[0]) {
            flags1.push(displayFlags1[0])

            if (displayFlags1[1]) {
              flags1[flags1.length - 1] += `: ${displayFlags1[1]}`
            }
          }

          const isHaveIntegral2 = data[dimension.id2 + 'Integral']
          const displayFlags2 = data[dimension.id2 + 'DisplayFlags'] || []
          const flags2 = []

          if (isHaveIntegral2) {
            flags2.push('重积分')
          }

          if (displayFlags2[0]) {
            flags2.push(displayFlags2[0])

            if (displayFlags2[1]) {
              flags2[flags2.length - 1] += `: ${displayFlags2[1]}`
            }
          }

          return [{
            marker: '<span></span>',
            seriesName: '比值',
            value: data && Number.isFinite(data.value) ? data.value.toFixed(3) : '--',
            unit: ''
          }, {
            marker: '<span></span>',
            seriesName: dimension.name1,
            value: data && Number.isFinite(data[dimension.id1]) ? data[dimension.id1] : '--',
            unit: dimension.displayUnit1,
            isHaveIntegral: (data && data[dimension.id1 + 'Integral']) ? data[dimension.id1 + 'Integral'] : false,
            noDataReason: data && data[dimension.id1 + '-noDataReason'] ? data[dimension.id1 + '-noDataReason'] : null,
            displayFlag: flags1.join(', ')
          }, {
            marker: '<span></span>',
            seriesName: dimension.name2,
            value: data && Number.isFinite(data[dimension.id2]) ? data[dimension.id2] : '--',
            unit: dimension.displayUnit1,
            isHaveIntegral: (data && data[dimension.id1 + 'Integral']) ? data[dimension.id2 + 'Integral'] : false,
            noDataReason: data && data[dimension.id2 + '-noDataReason'] ? data[dimension.id2 + '-noDataReason'] : null,
            displayFlag: flags2.join(', ')
          }]
        },
        seriesParam: {
          type: 'line',
          showSymbol: false,
          markLine: {
            name: `${name1}/${name2}比值`,
            data: [{
              name: `${name1}/${name2}比值`,
              yAxis: ratioLow
            }],
            lineStyle: {
              type: 'solid',
              color: 'red'
            }
          }
        }
      }]
      let newSeriesMap = dataTimes.reduce((map, dataTimeObj) => {
        let dataTime = dataTimeObj[1]
        let flag = 0

        let data1 = series1[dataTime]
        let value1 = null
        if (data1) {
          value1 = data1.value
          flag |= 1
        }

        let data2 = series2[dataTime]
        let value2 = null
        if (data2) {
          value2 = data2.value
          flag |= 2
        }

        if (flag > 0) {
          let value = null
          if (flag === 3 && value2 !== 0) {
            value = value1 / value2
          }

          let newData = map[ratioId][dataTime] = {
            ts: dataTimeObj[0],
            dataTime,
            value,
            [dimensionId1]: value1,
            [dimensionId1 + 'DisplayFlags']: data1 ? data1.displayFlags : [],
            [dimensionId1 + 'Integral']: (data1 && data1.isHaveIntegral) ? data1.isHaveIntegral : false,
            [dimensionId2]: value2,
            [dimensionId2 + 'DisplayFlags']: data2 ? data2.displayFlags : [],
            [dimensionId2 + 'Integral']: (data2 && data2.isHaveIntegral) ? data2.isHaveIntegral : false
          }

          if (Number.isFinite(value) && value < ratioLow) {
            if (!map['abnormal']) {
              map['abnormal'] = {}
              newDimensions.push({
                id: 'abnormal',
                name: 'abnormal',
                stdUnit: '',
                displayUnit: '',
                getTooltip: () => [],
                seriesParam: {
                  type: 'scatter',
                  symbolSize: 16,
                  color: 'red',
                  z: 3
                }
              })
            }

            map['abnormal'][dataTime] = newData
            return map
          }
        }

        const noDataReason1 = data1 ? data1.noDataReason : ''
        const noDataReason2 = data2 ? data2.noDataReason : ''

        if (noDataReason1 || noDataReason2) {
          map[ratioId][dataTime] = {
            ts: dataTimeObj[0],
            dataTime,
            [dimensionId1 + '-noDataReason']: noDataReason1,
            [dimensionId2 + '-noDataReason']: noDataReason2,
            [dimensionId1 + 'DisplayFlags']: data1 ? data1.displayFlags : [],
            [dimensionId2 + 'DisplayFlags']: data2 ? data2.displayFlags : []
          }
        }

        return map
      }, {
        [ratioId]: {}
      })

      return {
        ...dataConfig,
        dimensions: newDimensions,
        seriesMap: newSeriesMap
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/02Species-Ratio/RatioChart.vue